import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components/button';
import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts/modal-context';

import { ModalName } from '../types';
import * as Styled from './coin-race-rules-modal.styled';

export type CoinRaceRulesModalData = {
	title?: string;
	content: string;
};

const CoinRaceRulesModal = () => {
	const { t } = useTranslation('coin_race_details')
	const { isModalOpen, closeModal, getModalData } = useModals();

	const modalData = getModalData<CoinRaceRulesModalData>(ModalName.COIN_RACE_RULES);

	if (!modalData) {
		return null;
	}

	return (
		<Modal
			isOpen={isModalOpen(ModalName.COIN_RACE_RULES)}
			title={modalData.title || t('rules')}
			closeModal={closeModal}
		>
			<Styled.Wrapper>
				<Styled.Content dangerouslySetInnerHTML={{ __html: modalData.content }} />
				<Styled.Footer>
					<Button color='dark' onClick={closeModal}>
						{t('close')}
					</Button>
				</Styled.Footer>
			</Styled.Wrapper>
		</Modal>
	);
};

export default CoinRaceRulesModal;

